export * from './BookClosedGovIcon';
export * from './BookClosedGovIcon16Light';
export * from './BookClosedGovIcon16Regular';
export * from './BookClosedGovIcon16Solid';
export * from './BookClosedGovIcon20Light';
export * from './BookClosedGovIcon20Regular';
export * from './BookClosedGovIcon20Solid';
export * from './BookClosedGovIcon24Regular';
export * from './BookClosedGovIcon24Solid';
export * from './BookClosedGovIcon32Regular';
export * from './BookClosedGovIcon64Regular';
